import { useEffect, useState } from "react";
import Text from "../../../../components/ui/Text";
import { PlayerType } from "./Players";
import Button from "../ui/Button";
import circleFullImage from "../../assets/images/circle-full.png";
import circleEmptyImage from "../../assets/images/circle-empty.png";

interface Props {
  className?: string;
  player: PlayerType;
  title?: string;
  description?: string;
  submitTitle?: string;
  onSubmit: (player: PlayerType, newRole: Role) => void;
  onModalClose: () => void;
}

type Role = "Admin" | "Moderator" | "Owner" | "Police" | "Attacker" | "Guest";

const SetRoleModal = ({
  className = "",
  player,
  title = "Selecting Role",
  submitTitle = "Submit",
  description = "For player",
  onModalClose,
  onSubmit,
}: Props) => {
  const [roles /*setRoles */] = useState<Role[]>([
    "Admin",
    "Attacker",
    "Moderator",
    "Police",
    "Owner",
    "Guest",
  ]);
  const [selectedRole, setSelectedRole] = useState<Role>();

  useEffect(() => {
    setSelectedRole(player?.role as Role);
  }, [player?.role]);

  return (
    <div
      className={`bg-gradient-to-b from-[#494864] to-[#161820] p-5 rounded-md relative ${className}`}
    >
      <button
        title="Close"
        className="text-red-500 text-sm absolute top-2 right-2 cursor-pointer"
        onClick={onModalClose}
      >
        X
      </button>
      <Text
        size="sm"
        className="!font-semibold text-[#BEB9FF] text-center leading-[105%]"
      >
        {title}
      </Text>
      <Text size="xxs" className="text-center text-[#BEB9FF8C]/45">
        {description}
      </Text>

      <div className="overflow-y-scroll scrollbar-hide max-h-[190px] py-3 pb-[4rem] mt-1 space-y-2">
        {roles?.map((role, i) => {
          return (
            <Button
              variant="light-gray"
              innerClassName="flex items-center justify-between"
              onClick={() => {
                setSelectedRole(role);
              }}
              key={i}
            >
              <Text className="text-white/70 flex-1" size="xxs">
                {role}
              </Text>
              <img
                alt="role"
                src={selectedRole === role ? circleFullImage : circleEmptyImage}
                className="w-[15px] h-[15px]"
              />
            </Button>
          );
        })}
      </div>

      <Button
        variant="blue"
        className="absolute bottom-9 left-0 right-0"
        onClick={() => {
          if (!selectedRole) return;
          onSubmit(player, selectedRole as Role);
        }}
      >
        <Text size="xxs" className="text-white">
          {submitTitle}
        </Text>
      </Button>
    </div>
  );
};

export default SetRoleModal;
